import React from 'react';
import { Link } from 'react-router-dom';

const Featured = ({ allItems }) => {
    const featured = allItems.slice(0, 6);

    return (
        <section id="featured" className="pt-0 py-sm-5 container">
            <h1 className="text-center my-5 title"><b>Featured Products</b></h1>
            <div className="card-columns">
                {
                    featured.map(item => <div className="card border-0 shadow" key={item.id}>
                        <img src={item.data.photo} alt={item.data.name} className="img-fluid card-image-top" />
                        <div className="card-body text-center">
                            <h5><b>{item.data.name}</b></h5>
                            <h6 className="text-secondary">Price: {item.data.price}/=</h6>
                        </div>
                    </div>)
                }
            </div>
            <div className="text-center mt-5">
                <Link to="/products" onClick={() => window.scrollTo(0, 0)} className="btn btn-one text-white">See All Products</Link>
            </div>
        </section>
    );
};

export default Featured;